import React, { useState, useEffect, useRef } from 'react';
import { useNavigate,useParams  } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import ReplyIcon from '@mui/icons-material/Reply';
import InputLabel from '@mui/material/InputLabel';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import SendIcon from '@mui/icons-material/Send';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import RadioGroup from '@mui/material/RadioGroup';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Alert from '@mui/material/Alert';
import { v4 as uuidv4 } from 'uuid';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import CloseIcon from '@mui/icons-material/Close';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import SearchIcon from '@mui/icons-material/Search';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import NativeSelect from '@mui/material/NativeSelect';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Document, Page, Text, StyleSheet, View, Image,PDFDownloadLink ,PDFViewer ,Font ,Svg, pdf } from '@react-pdf/renderer';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Slide from '@mui/material/Slide';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import apiClient from '../ApiClient/ApiClient';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const COMPANY_DISPLAY_MAP = {
    "23032911": "華辰",
    "34005573": "福蒙",
    "99999999": "FIRM",
    "00047613": "福鋼",
    HC: "華辰",
    FM: "福蒙",
};

const toCompanyDisplay = (value) => COMPANY_DISPLAY_MAP[value] || value || '';
const defaultPurchaseCompany = () => toCompanyDisplay(sessionStorage.getItem('company')) || '華辰';

const formatItemOptionPrice = (item) =>
    Number(item.單價 ?? 0).toFixed(item.幣別?.trim().toUpperCase() === 'TWD' ? 2 : 3);

export default function BuyBill() {

    const [canEditPurchase, setCanEditPurchase] = useState(false);
    const [canPrintPurchase, setCanPrintPurchase] = useState(false);
    const [inventoryControl, setInventoryControl] = useState(true);
    const addGridApiRef = useGridApiRef();
    const activeAddEditCellRef = useRef(null);

    const columns = [
     
      {   field: 'id', headerName: 'ID', width: 90 },
      {
          field: '單號',
          headerName: '單號',
          width: 100,
          editable: true,
      },
      {
          field: '廠商',
          headerName: '廠商',
          width: 100,
          editable: true,
      },
    ];
    const billcolumns = [
     
        {
            field: "操作",
            headerName: "操作",
            width: 80,
            renderCell: (params) => canEditPurchase ? (
              <IconButton
                onClick={() => handleDeleteClick(params)} // 点击按钮时调用删除处理函数
                color="primary"
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
            ) : null,
        },
        {
            field: '圖號',
            headerName: '圖號',
            width: 130,
            editable: true,
        },
        {
            field: '物品名',
            headerName: '物品名',
            width: 200,
            editable: true,
        },
        {
            field: '單位',
            headerName: '單位',
            width: 80,
            editable: true,
        },
        {
            field: '數量',
            headerName: '數量',
            width: 80,
            editable: true,
            type: 'number',
            align: 'right',
            headerAlign: 'right',
            valueFormatter: ({ value }) => Number(value ?? 0).toFixed(2),
        },
        {
            field: '單價',
            headerName: '單價',
            width: 80,
            editable: false,
            align: 'right',
            headerAlign: 'right',
            valueFormatter: ({ value }) => priceFmt.format(Number(value ?? 0)),
        },
        {
            field: '金額',
            headerName: '金額',
            width: 100,
            editable: true,
        },
        {
            field: '批號',
            headerName: '批號',
            width: 120,
            editable: true,
        },
        {
            field: 'memo',
            headerName: '備註',
            width: 120,
            editable: true,
        },        
        {   field: 'id', headerName: 'ID', width: 90 },
    
    ];
    const addBillcolumns = [
     
        {   field: 'id', headerName: 'ID', width: 90 },
        {
            field: '圖號',
            headerName: '圖號',
            width: 200,
            editable: true,
        },
        {
            field: '物品名',
            headerName: '物品名',
            width: 200,
            editable: true,
        },
        {
            field: '單位',
            headerName: '單位',
            width: 100,
            editable: true,
        },
        {
            field: '數量',
            headerName: '數量',
            width: 100,
            editable: true,
        },
        {
            field: '單價',
            headerName: '單價',
            width: 100,
            editable: true,
        },
        {
            field: '金額',
            headerName: '金額',
            width: 100,
            editable: true,
        },
        {
            field: '批號',
            headerName: inventoryControl ? '批號（庫存必填）' : '批號（選填）',
            width: 150,
            editable: true,
        },
        {
            field: "操作",
            headerName: "操作",
            width: 150,
            renderCell: (params) => (
              <IconButton
                onClick={() => handleAddRowsDelete(params.row.id)} // 点击按钮时调用删除处理函数
                color="primary"
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
            ),
          },
    
    ];
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const [totalMoney,setTotalMoney] = useState(0);
    const [rows, setRows] = React.useState([]);
    const [oldDataPagination, setOldDataPagination] = React.useState({
        page: 0,
        pageSize: 10,
    });
    const [printRows, setPrintRows] = React.useState([]);
    const [billRows, setBillRows] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [addBillRows, setAddBillRows] = React.useState([]);
    const [addEditBillRows, setAddEditBillRows] = React.useState([]);
    const [priceDialogOpen, setPriceDialogOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);



    const [options, setOptions] = React.useState([]);
    const [editedRows, setEditedRows] = React.useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectMonth, setSelectMonth] = React.useState(dayjs(formattedDate));
    const [drawNum,setDrawNum] = useState('');   
    const [orderNum,setOrderNum] = useState('');   
    const [other, setOther] = React.useState('');   
    const [request,setRequest] = useState({
        id:0,
        公司:defaultPurchaseCompany(),
        廠商:'',
        主管:'',
        核准:'',
        聯絡人:'尚未選擇',
        單號:'new',
        電話:'尚未選擇',
        傳真:'尚未選擇',
        日期: formattedDate, // 設置採購日期為當天
        需求日期: formattedDate, // 設置需求日為當天
        採購類別:'外購',
        申請人:'',
        備註:'',
        列印:''
    });
    const [open, setOpen] = React.useState(false);
    const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
    const [pdfOpen, setPdfOpen] = React.useState(false);
    const [detailsOpen, setDetailsOpenOpen] = React.useState(false);
    const [detailOptions, setDetailsOptions] = React.useState([]);
    const [item, setItem] = React.useState('');
    useEffect(() => {
        const fetchCurrentPermissions = async () => {
            try {
                const response = await apiClient.get('/PurchasePrice/CurrentPermissions');
                setCanEditPurchase(Boolean(response.data?.canEdit));
                setCanPrintPurchase(Boolean(response.data?.canPrint));
            } catch (error) {
                setCanEditPurchase(false);
                setCanPrintPurchase(false);
                console.error('讀取請採購單權限失敗:', error);
            }
        };

        fetchCurrentPermissions();
    }, []);

    const handleClickOpen = () => {
      setOpen(true);
    };

    
    // 確認更新資料回傳時的資料型態與後端相符
    const mapToBackendBill = (row) => ({
        公司: row.公司 || '',
        單號: row.單號 || '',
        日期: row.日期 ? new Date(row.日期) : null,
        需求日: row.需求日 ? new Date(row.需求日) : null,
        廠商: row.廠商 || '',
        序: row.序 || '',
        圖號: row.圖號 || '',
        物品名: row.物品名 || '',
        規格: (row.規格 || '').substring(0, 25),
        單位: row.單位 || '',
        單價: Number(row.單價) || 0,
        Pric: row.pric || '',
        數量: Number(row.數量) || 0,
        金額: Number(row.金額) || 0,
        批號: row.批號 || '',
        類別: row.類別 || '',
        申請人: row.申請人 || '',
        主管: row.主管 || '',
        核准: row.核准 || '',
        核准日: row.核准日 ? new Date(row.核准日) : null,
        列印: row.列印 || '',
        機種: row.機種 || '',
        狀況: row.狀況 || '',
        Qty: row.數量?.toString() || '0',
        入庫量: row.入庫量 || '',
        生產序號: row.生產序號 || '',
        Pk: Number(row.Pk) || 0,
        memo: row.memo || '',
        Id: row.id ? Number(row.id) : 0
    });

    const handleDetailsClickOpen = () => {
        setDetailsOpenOpen(true);
    };
    const handleDetailsClickClose = () => {
        setDetailsOpenOpen(false);
        setAddEditBillRows([]);
        setAddBillRows([]);
    };

    const priceFmt = new Intl.NumberFormat('zh-TW', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
        roundingMode: 'halfExpand', // 四捨五入（ties away from zero）
      });
  
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data === 'handleOKClick') {
                handleOKClick();
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);
    

    const handlePdfClickOpen = () => {
        setPdfOpen(true);
    };
    const handlePdfClickClose = () => {
        setPdfOpen(false);
    };

    const handleAfterPrintPdfClickClose = () => {
        handleOKClick();
        setPdfOpen(false);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const handleDetailsOptionsClick = async (no) => {
        setLoading(true);
            const vendorParam = encodeURIComponent(request.廠商);
        try {    
            const response = await apiClient.get(`/PurchasePrice/ItemOptions?num=${no}&vendor=${vendorParam}`);
            if (response.status === 200) {
                setDetailsOptions(response.data);    
            }
            } catch (error) {
                console.error('Error fetching data:', error);
            }finally{
                setLoading(false);
            }
      };

      const handleOKClick = async () => {
        setLoading(true);
        try {    
            const response = await apiClient.post('/PurchasePrice/OkData', null, {
                params: { num: billRows[0].單號 },
            });
            if (response.status === 200) {
                alert('修改採購列印OK');
            }
            } catch (error) {
                console.error('Error fetching data:', error);
            }finally{
                setLoading(false);
            }
    };

    const handleCellClick = async (param) => {
        setLoading(true);
        try {    
            const response = await apiClient.get(`/PurchasePrice/BuyBillsByNum?num=${param.row.單號}`);
            setOrderNum(param.row.單號);
            if(response.data.length === 0) {
                alert('找不到資料');
                return;
            }

            if(response.data[0].類別 !== '外購' && response.data[0].類別 !== '合約' && response.data[0].類別 !== '託外') {
                setOther(response.data[0].類別);
            }
            if (response.status === 200) {
                setRequest({
                    ...request,
                    公司: toCompanyDisplay(response.data[0].公司),
                    廠商:response.data[0].廠商, 
                    單號:response.data[0].單號,
                    日期:response.data[0].日期.split("T")[0],
                    需求日期:response.data[0].需求日.split("T")[0],
                    採購類別:response.data[0].類別,
                    申請人:response.data[0].申請人,
                    主管:response.data[0].主管,
                    核准:response.data[0].核准,
                    備註:response.data[0].memo === null? '':response.data[0].memo,
                    列印:response.data[0].列印
                })
                const selectedOption = options.find(option => option.manufacturer_AbbreviationName === response.data[0].廠商);
                setSelectedOption(selectedOption)
                setBillRows(response.data)
                setEditedRows([]);
            }
            } catch (error) {
            console.error('Error fetching data:', error);
            }finally{
                setLoading(false);
            }
      };

    const handleSearchClick = async () => {
        setLoading(true);
        try {    
            const response = await apiClient.get(`/PurchasePrice/BuyBillsByNum?num=${orderNum}`);
            if(response.data.length === 0) {
                alert('找不到資料');
                return;
            }
            if(response.data[0].類別 !== '外購' && response.data[0].類別 !== '合約' && response.data[0].類別 !== '託外') {
                setOther(response.data[0].類別);
            }
            if (response.status === 200) {
                setRequest({
                    ...request,
                    公司: toCompanyDisplay(response.data[0].公司),
                    廠商:response.data[0].廠商, 
                    單號:response.data[0].單號,
                    日期:response.data[0].日期.split("T")[0],
                    需求日期:response.data[0].需求日.split("T")[0],
                    採購類別:response.data[0].類別,
                    申請人:response.data[0].申請人,
                    主管:response.data[0].主管,
                    核准:response.data[0].核准,
                    備註:response.data[0].備註,
                    列印:response.data[0].列印
                })
                const selectedOption = options.find(option => option.manufacturer_AbbreviationName === response.data[0].廠商);
                setSelectedOption(selectedOption)
                setBillRows(response.data)
                setEditedRows([]);
                handleClose();
            }
            } catch (error) {
            console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };

    const handlePrintClick = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(`/Buyer/PrintData?orderNum=${orderNum}`, {
                responseType: 'json'
            });
    
            console.log('Response Status:', response.status);
            console.log('Response Data:', response.data);
    
            if (response.status === 200 && response.data) {
                const { pdfContent, warehouseBool, approvalBool } = response.data;
    
                if (warehouseBool === true) {
                    alert('此單已入庫，無法列印');
                    return;
                }
    
                if (approvalBool === true) {
                    alert('此單尚未核准，無法列印');
                    return;
                }
    
                if (pdfContent) {
                    const byteCharacters = atob(pdfContent);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i+=1) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
    
                    const blobUrl = URL.createObjectURL(pdfBlob);
    
                    // 開啟新視窗，內含 PDF 和按鈕
                    const newWindow = window.open('', '_blank', 'width=1000,height=800');
                    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                        alert('瀏覽器封鎖了新視窗，請允許彈出視窗');
                        return;
                    }
    
                    newWindow.document.write(`
                        <html>
                            <head><title>PDF 預覽</title></head>
                            <body style="margin:0;padding:0;">
                                <iframe src="${blobUrl}" width="100%" height="95%" style="border:none;"></iframe>
                                <div style="text-align:center; margin-top:10px;">
                                    <button style="padding:10px 20px; font-size:16px;" onclick="window.opener.postMessage('handleOKClick', '*'); window.close();">
                                        按此關閉並儲存列印狀態
                                    </button>
                                </div>
                            </body>
                        </html>
                    `);
                    newWindow.document.close(); // 確保渲染
                } else {
                    alert('PDF內容為空');
                }
            } else {
                alert('响应数据无效');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };
    
    // === 數字處理工具 ===
const DIGITS = 2; // 金額要四捨五入到幾位小數（要兩位就改 2）

const toInt = (v) => {
  if (v == null || v === '') return 0;
  if (typeof v === 'number') return Number.isFinite(v) ? Math.trunc(v) : 0;
  const n = Number(String(v).replace(/[,\s]/g, ''));
  return Number.isFinite(n) ? Math.trunc(n) : 0;
};

const toQty = (v) => {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
    const n = Number(String(v).replace(/[,\s]/g, ''));
    return Number.isFinite(n) ? n : 0;
  };

const toDec = (v) => {
  if (v == null || v === '') return 0;
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  const n = Number(String(v).replace(/[,\s]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

const roundN = (n, digits = DIGITS) => {
    const f = 10 ** digits;           // ← 取代 Math.pow(10, digits)
    return Math.round(n * f) / f;
  };
  

// === 轉成後端 PurchaseViewModel 的乾淨物件 ===
const normalizePurchaseRow = (row, fallbackOrderNo) => {
  const qty   = toQty(row.數量);
  const price = toDec(row.單價);
  const amount = row.金額 != null && row.金額 !== ''
    ? toDec(row.金額)
    : roundN(price * qty, DIGITS);

  return {
    圖號 : row.圖號 || '',
    物品名: row.物品名 || '',
    單位 : row.單位 || '',
    數量 : qty,              // int
    單價 : price,            // decimal
    金額 : amount,           // decimal
    單號 : row.單號 || fallbackOrderNo || null,
    批號 : row.批號 || null,
    Id   : Number.isFinite(row?.id) ? row.id : 0,
  };
};

    

    const handleDeleteClick = async (param) => {
        if (!canEditPurchase) {
            alert('權限不足，無法刪除採購資料');
            return;
        }

        const confirmed = window.confirm(`確定要刪除圖號「${param.row.圖號 || ''}」嗎？刪除後將同步反向處理庫存。`);
        if (!confirmed) return;

        setLoading(true);
        try {    
            const response = await apiClient.delete('/PurchasePrice/Remove', {
                params: { num: request.單號, id: param.row.id },
            });
            if(response.data.length === 0) {
                setBillRows([]);
                setEditedRows([]);
                alert('刪除成功，庫存已同步還原');
                return;
            }
            if(response.data[0].類別 !== '外購' && response.data[0].類別 !== '合約' && response.data[0].類別 !== '託外') {
                setOther(response.data[0].類別);
            }
            if (response.status === 200) {
                setRequest({
                    ...request,
                    公司: toCompanyDisplay(response.data[0].公司),
                    廠商:response.data[0].廠商, 
                    單號:response.data[0].單號,
                    日期:response.data[0].日期.split("T")[0],
                    需求日期:response.data[0].需求日.split("T")[0],
                    採購類別:response.data[0].類別,
                    申請人:response.data[0].申請人,
                    主管:response.data[0].主管,
                    核准:response.data[0].核准,
                    備註:response.data[0].備註,
                    列印:response.data[0].列印
                })
                const selectedOption = options.find(option => option.manufacturer_AbbreviationName === response.data[0].廠商);
                setSelectedOption(selectedOption)
                setBillRows(response.data)
                setEditedRows([]);
                handleClose();
                alert('刪除成功，庫存已同步還原');
            }
            } catch (error) {
            console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };




    const handleSubmit = async (isControl) => {
        if (!request.公司?.trim()) {
          alert('請選擇採購公司');
          return;
        }
        if (!request.採購類別?.trim()) {
          alert('請選擇採購類別');
          return;
        }
        const vendor = request.廠商?.trim() || selectedOption?.manufacturer_AbbreviationName?.trim() || '';
        if (!vendor) {
          alert('請選擇廠商');
          return;
        }
        if (!request.日期 || !request.需求日期) {
          alert('日期跟需求日期不得為空');
          return;
        }

        const coalesceVendor = () =>
        (request?.廠商 && request.廠商.trim() !== '')
        ? request.廠商
        : (selectedOption?.manufacturer_AbbreviationName ?? '');

        // 直接從 DataGrid 取得最新列值；即使游標仍停在編輯中的批號儲存格，
        // getRowWithUpdatedValues 也會包含使用者尚未離開儲存格的輸入值。
        const rowModels = addGridApiRef.current?.getRowModels?.();
        let unique = rowModels ? Array.from(rowModels.values()) : addBillRows;
        const activeCell = activeAddEditCellRef.current;
        if (activeCell && unique.some(row => row.id === activeCell.id)) {
          if (addGridApiRef.current?.getCellMode?.(activeCell.id, activeCell.field) === 'edit') {
            const editingRow = addGridApiRef.current.getRowWithUpdatedValues(activeCell.id, activeCell.field);
            unique = unique.map(row => row.id === editingRow.id ? editingRow : row);
          }
        }

        const missingBatchRow = isControl
          ? unique.find(row => {
              const batchNo = row.批號?.trim() || '';
              return row.requiresInventoryCard &&
                (!batchNo || batchNo.toLowerCase() === 'new');
            })
          : null;

        if (missingBatchRow) {
          alert(`圖號「${missingBatchRow.圖號}」需要寫入資材卡，請填寫批號`);
          return;
        }
      
        // 轉成後端需要的乾淨型別
        const normalized = unique.map(r => normalizePurchaseRow(r, request.單號));
      
        const dataToSend = {
          BaseSet: { ...request, 廠商: vendor },
          // 建議用 .NET 慣例的 PascalCase；雖然不分大小寫，但對齊比較不會踩雷
          PurchaseViewModels: normalized,
          IsControl: Boolean(isControl),
        };
      
        console.log('送出的資料：', dataToSend);
        setLoading(true);
        try {
          const response =  await apiClient.post(`/PurchasePrice/AddPurchaseBills`, dataToSend, {
            headers: { 'Cache-Control': 'no-store' },
          });
          if (response.status === 200) {
            alert('新增採購成功');
            setAddBillRows(response.data);
            setBillRows(response.data);
            setRequest({
              ...request,
              公司  : toCompanyDisplay(response.data[0].公司),
              廠商  : response.data[0].廠商,
              單號  : response.data[0].單號,
              日期  : response.data[0].日期.split('T')[0],
              需求日期: response.data[0].需求日.split('T')[0],
              採購類別: response.data[0].類別,
              申請人: response.data[0].申請人,
              主管  : response.data[0].主管,
              核准  : response.data[0].核准,
              備註  : response.data[0].備註,
              列印  : response.data[0].列印,
            });
          } else {
            console.error('Server responded with status:', response.status);
          }
        } catch (error) {
          console.error('Error submitting data:', error);
          alert(error.response?.data?.message || '新增採購失敗');
        } finally {
          setLoading(false);
        }
      };
      

    const handlereplace = async () => {
    setBillRows(prev => {
        const lastRow = prev[prev.length - 1] || {};
        const newRows = [...prev];

        // 取得現有最大 id
        const existingIds = prev.map(row => typeof row.id === 'number' ? row.id : -1);
        let nextId = Math.max(...existingIds, -1) + 1;

        for (let i = 0; i < addEditBillRows.length; i += 1) {
            if (i > 4) break; // 最多只加入 id = 0~4

            const editRow = addEditBillRows[i];
            const newRow = { ...lastRow };

            // 覆蓋欄位
            Object.keys(editRow).forEach(key => {
                newRow[key] = editRow[key];
            });

            newRow.id = nextId;
            newRow.Pk = i+1; // 寫入遞增的 Pk
            nextId += 1;

            newRows.push(newRow);
        }

        return newRows;
    });
    };

    
    
    const handleUpdatePrice = async (row) => {
        if (!row || !row.圖號) return;
      
        setLoading(true);
        try {
          // 後端回傳 { price: 123.45 }
          const response = await apiClient.get(`/PurchasePrice/GetLatestPrice?drawNum=${encodeURIComponent(row.圖號)}`);
          if (response.status === 200 && response.data && response.data.price !== undefined) {
            const newPrice = Number(response.data.price);
      
            // 建議：所有有這個圖號的行都一起改
            setBillRows((prevRows) =>
              prevRows.map((item) =>
                item.圖號 === row.圖號
                  ? {
                      ...item,
                      單價: newPrice,
                      金額: roundN(newPrice * (Number(item.數量) || 0), DIGITS),
                    }
                  : item
              )
            );
            alert('單價已更新');
          } else {
            alert('查無單價');
          }
        } catch (error) {
          console.error('取得單價失敗:', error);
          alert('查詢失敗');
        } finally {
          setLoading(false);
        }
      };
      

    const fetchData = async () => {   
        setLoading(true);      
            const com = selectedOption == null? '':selectedOption.manufacturer_AbbreviationName;
            console.log(selectMonth);
            try {    
            const response = await apiClient.get(`/PurchasePrice/BuyBills?month=${selectMonth.month() + 1}&com=${com}&year=${selectMonth.year()}`);
            if (response.status === 200) {
                setRows(response.data);
                setOldDataPagination((prev) => ({ ...prev, page: 0 }));
            }
            } catch (error) {
            console.error('Error fetching data:', error);
            alert(error.response?.data?.message || '刪除失敗，資料與庫存均未變更');
        }finally{
                setLoading(false);
            }
    };
    const resetData = async () => {
        setRequest({
            id:0,
            公司:defaultPurchaseCompany(),
            廠商:'',
            聯絡人:'尚未選擇',
            單號:'new',
            電話:'尚未選擇',
            傳真:'尚未選擇',
            日期:'',
            需求日期:'',
            採購類別:'外購',
            主管:'',
            核准:'',
            申請人:'',
            列印:'',
            備註:''
        })
    };
    // const fetchDrawNumData = async () => {         
    //     try {    
    //         const response = await axios.get(`${apiUrl}/PurchasePrice/ItemDetail?num=${drawNum}`);
    //         if (response.status === 200) {
    //             // 使用展开运算符将新的对象添加到前一个状态数组的末尾
    //             setBillRows(prevBillRows => [...prevBillRows, response.data]);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    // const handleDelete = (id) => {
    //     const newData = billRows.filter((row) => row.id !== id);
    //     setBillRows(newData);
    // };

    const handleAddRowsDelete = (id) => {
        setAddBillRows((previousRows) => previousRows.filter((row) => row.id !== id));
        setAddEditBillRows((previousRows) => previousRows.filter((row) => row.id !== id));
        if (activeAddEditCellRef.current?.id === id) {
          activeAddEditCellRef.current = null;
        }
    };
    
    const fetchOptions = async () => {
        setLoading(true);
        try {    
          const response = await apiClient.get(`/Manufacturer/list`);
          if (response.status === 200) {
            setOptions(response.data.manufacturers);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }finally{
            setLoading(false);
        }
    };
    const handleChange = (event, newValue) => {
        setSelectedOption(newValue);
        if(newValue === null || newValue === undefined) return;
        setRequest((prevRequest) => ({   
            ...prevRequest,
            廠商: newValue.manufacturer_AbbreviationName || "",
            聯絡人: newValue.manufacturer_ContactName || "",
            電話: newValue.manufacturer_CompanyPhone || "",
            傳真: newValue.manufacturer_CompanyFax || "",
        })); 
    };

    const handleEdit = async (isControl) => {
        if (!request.公司?.trim()) {
            alert('請選擇採購公司');
            return;
        }
        if (!request.採購類別?.trim()) {
            alert('請選擇採購類別');
            return;
        }
        const vendor = request.廠商?.trim() || selectedOption?.manufacturer_AbbreviationName?.trim() || '';
        if (!vendor) {
            alert('請選擇廠商');
            return;
        }

        setLoading(true);
    
        // 將 editedRows 合併到 billRows，以確保所有修改後的欄位（如：批號）都正確傳入
        const updatedRows = billRows.map(row => {
            const editedRow = editedRows.find(r => r.id === row.id);
            return editedRow ? { ...row, ...editedRow } : row;
        });
        const coalesceVendor = () =>
        (request?.廠商 && request.廠商.trim() !== '')
                ? request.廠商
            : (selectedOption?.manufacturer_AbbreviationName ?? '');

        const payload = {
            公司: request.公司 || '',
            單號: request.單號,
            日期: request.日期 ? new Date(request.日期) : null,
            需求日期: request.需求日期 ? new Date(request.需求日期) : null,
            廠商: coalesceVendor(),
            採購類別: request.採購類別,
            申請人: request.申請人,
            備註: request.備註?.trim() || '（無）',
            聯絡人: request.聯絡人 || '',
            主管: request.主管,
            核准: request.核准?.trim() || '',
            列印: request.列印 || "",
            Id: request.Id || 0,
            IsControl: Boolean(isControl),
            Bills: updatedRows.map(mapToBackendBill),
        };
    
        console.log('📤 送出 payload:', JSON.stringify(payload, null, 2));
    
        try {
            const response = await apiClient.post(`/PurchasePrice/EditBuyBill`, payload, {
                headers: { 'Cache-Control': 'no-store' },
              });
    
            if (response.status === 200 && response.data.length > 0) {
                alert('更新成功');
    
                setRequest({
                    ...request,
                    公司: toCompanyDisplay(response.data[0].公司),
                    廠商: response.data[0].廠商,
                    單號: response.data[0].單號,
                    日期: response.data[0].日期.split("T")[0],
                    需求日期: response.data[0].需求日.split("T")[0],
                    採購類別: response.data[0].類別,
                    申請人: response.data[0].申請人,
                    主管: response.data[0].主管,
                    核准: response.data[0].核准,
                    備註: response.data[0].備註,
                    列印: response.data[0].列印
                });
    
                const selectedOption = options.find(option => option.manufacturer_AbbreviationName === response.data[0].廠商);
                setSelectedOption(selectedOption);
                setBillRows(response.data);
                setEditedRows([]);
                handleClose();
            } else {
                alert('更新失敗或找不到資料');
            }
        } catch (error) {
            console.error('Error editing data:', error);
            alert('伺服器錯誤，請稍後再試');
        } finally {
            setLoading(false);
        }
    };
    


    const handleRequestInputChange = (value, fieldName) => {
        setRequest((prevRequest) => ({
            ...prevRequest,
            [fieldName]: value.target ? value.target.value : value, // conditional check for value
        }));   
    };

    const processAddRowUpdate = (newRow, oldRow) => {
        // 將數量轉換為數字，可保留小數
        const parsedQty = parseFloat(newRow.數量) || 0;
    
        let updatedRow = {
            ...newRow,
            數量: parsedQty,
        };
    
        if (oldRow && parsedQty !== oldRow.數量) {
            const totalAmount = newRow.單價 * parsedQty;
    
            updatedRow = {
                ...updatedRow,
                金額: roundN(totalAmount, DIGITS),   // ✅ 保留小數位
            };
        }
    
        setAddBillRows((previousRows) =>
          previousRows.map((row) => row.id === updatedRow.id ? updatedRow : row)
        );
        setAddEditBillRows((previousRows) => {
          const otherRows = previousRows.filter((row) => row.id !== updatedRow.id);
          return [...otherRows, updatedRow];
        });
        return updatedRow;
    };
    
    
    const handlePriceChangeDoubleClick = (params) => {
        setSelectedRow(params.row); // 存目前選中的 row
        setPriceDialogOpen(true);
      };

      const processRowUpdate = (newRow, oldRow) => {
        const next = { ...newRow };
      
        // 只有數量或單價變動才重算金額；改備註不影響金額
        if (
          oldRow &&
          (newRow.數量 !== oldRow.數量 || newRow.單價 !== oldRow.單價)
        ) {
          const qty = Number(newRow.數量) || 0;
          const price = Number(newRow.單價) || 0;
          next.金額 = roundN(price * qty, DIGITS);
        }
      
        // ✅ 立刻把畫面資料更新（來源統一用 billRows）
        setBillRows(prev => prev.map(r => (r.id === next.id ? { ...r, ...next } : r)));
      
        // ✅ 仍保留差異列，之後送後端用
        setEditedRows(prev => {
          const others = prev.filter(r => r.id !== next.id);
          return [...others, next];
        });
      
        return next;
      };
      

    // 直接用 billRows 算合計
const calculateTotalAmount = () => {
    const total = billRows.reduce((sum, r) => sum + (Number(r.金額) || 0), 0);
    setTotalMoney(Math.round(total));
  };

    const handleSave = async () => {
        const modifiedRows = editedRows.map(item => ({
          ...item,
        }));
    };

    const handleAddSave = async () => {
        const modifiedRows = addEditBillRows.map(item => ({
          ...item,
        }));
    };

    const handleDetailChange = (event) => {
    const selectedItem = event.target.value;

    setAddBillRows(prevAddBillRows => {
        const nextId = prevAddBillRows.length; // 從 0 開始遞增
        const newItem = { ...selectedItem, id: nextId };
        setItem(newItem);
        return [...prevAddBillRows, newItem];
    });
};

    

useEffect(() => {
    calculateTotalAmount();
  }, [billRows]);


    useEffect(() => {
        fetchOptions();
    }, []); 

    useEffect(() => {
        if(selectedOption !== null && selectedOption !== undefined) {
            setRequest((prevRequest) => ({   
                ...prevRequest,
                廠商: selectedOption.manufacturer_AbbreviationName || "",
                聯絡人: selectedOption.manufacturer_ContactName || "",
                電話: selectedOption.manufacturer_CompanyPhone || "",
                傳真: selectedOption.manufacturer_CompanyFax || "",
            })); 
        }
    }, [selectedOption]);

    return (
        <Box sx={{ width: '100%', height: 1000, overflow: 'hidden' }}>
            <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        >
        <CircularProgress color="inherit" />
        </Backdrop>
            <Grid container spacing={2} style={{ height: '100%' }}>
                {/* 第一個 DataGrid */}
                <Grid item xs={3} style={{ height: '100%', display: 'flex' }}>                   
                    <div style={{ flexGrow: 1, height: '100%', width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                                <DatePicker
                                label="月份選擇"
                                value={selectMonth}
                                onChange={(newValue) => setSelectMonth(newValue)}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={options}
                            sx={{ width: '100%' }}
                            value={selectedOption}
                            onChange={handleChange}
                            getOptionLabel={(option) => option.manufacturer_Seq+ option.manufacturer_AbbreviationName}
                            // 設置renderInput來渲染輸入元件
                            renderInput={(params) => <TextField {...params} label="廠商" />}
                        />
                        <Button variant="contained" style={{marginTop:'20px'}} onClick={fetchData}>搜尋</Button>
                        <Box sx={{ flex: 1, minHeight: 0, mt: 1 }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                pagination
                                paginationModel={oldDataPagination}
                                onPaginationModelChange={setOldDataPagination}
                                pageSizeOptions={[5, 10, 20, 50]}
                                onCellClick={handleCellClick}
                            />
                        </Box>
                    </div>
                </Grid>

                {/* 第二個 DataGrid */}
                <Grid item xs={9} style={{ height: '100%', display: 'flex' }}>
                    <div style={{ flexGrow: 1, height: '100%', width: '100%' }}>
                        <Box sx={{ flexGrow: 1,marginTop:'30PX' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">採購公司</InputLabel>
                                        <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={request.公司}
                                        label="Age"
                                        onChange={(e) => handleRequestInputChange(e.target.value, '公司')}
                                        >
                                        <MenuItem value='福蒙'>福蒙</MenuItem>
                                        <MenuItem value='華辰'>華辰</MenuItem>
                                        <MenuItem value='FIRM'>FIRM</MenuItem>
                                        <MenuItem value='福鋼'>福鋼</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">採購類別</InputLabel>
                                        <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={request.採購類別}
                                        label="Age"
                                        onChange={(e) => handleRequestInputChange(e.target.value, '採購類別')}
                                        >
                                        <MenuItem value='外購'>外購</MenuItem>
                                        <MenuItem value='合約'>合約</MenuItem>
                                        <MenuItem value='託外'>託外</MenuItem>
                                        <MenuItem value={other}>{other}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={options}
                                        value={selectedOption}
                                        sx={{ width: '100%' }}
                                        onChange={handleChange}
                                        getOptionLabel={(option) => option.manufacturer_Seq+ option.manufacturer_AbbreviationName}
                                        // 設置renderInput來渲染輸入元件
                                        renderInput={(params) => <TextField {...params} label="廠商" />}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="聯絡人" variant="outlined" value={request.聯絡人}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="電話" variant="outlined" value={request.電話}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="傳真" variant="outlined" value={request.傳真}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="單號" variant="outlined" value={request.單號}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="採購日期" variant="outlined" value={request.日期}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '日期')}
                                    placeholder='yyyy-mm-dd'/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="需求日" variant="outlined" value={request.需求日期}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '需求日期')}
                                    placeholder='yyyy-mm-dd'/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="採購擔當" variant="outlined" value={request.申請人}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '申請人')}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="採購主管" variant="outlined" value={request.主管}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '採購主管')}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="核准" variant="outlined" value={request.核准}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '核准')}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="列印" variant="outlined" value={request.列印}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '列印')}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField id="standard-basic" label="備註" variant="outlined" value={request.備註}
                                    onChange={(e) => handleRequestInputChange(e.target.value, '備註')}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                <TextField id="standard-basic" label="合計" variant="outlined" value={totalMoney} />
                                    </Grid>
                                        <Grid item xs={3}>
                                            <FormControlLabel
                                                control={
                                                <Checkbox
                                                checked={!!inventoryControl}
                                                onChange={(e) => setInventoryControl(Boolean(e.target.checked))}
                                                color="primary"
                                                />
                                                }
                                            label="庫存管制"
                                            />
                                        </Grid>

                                <Grid item xs={12}>
                                    <Button size="small" onClick={resetData}>清空</Button>
                                    {canEditPurchase && <Button size="small" onClick={() => handleEdit(inventoryControl)}>儲存更改</Button>}
                                    {canEditPurchase && <Button size="small" onClick={handleDetailsClickOpen}>新增資料</Button>}
                                    <Button size="small" onClick={handleClickOpen}>搜尋</Button>
                                   
                                    {canPrintPurchase && canEditPurchase && <Button size="small" onClick={handlePrintClick}>列印</Button>}
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <TextField id="outlined-basic" label="圖號" variant="outlined" value={drawNum} onChange={(e)=>setDrawNum(e.target.value)}/>
                                </Grid> */}
                                <Dialog                                  
                                    open={detailsOpen}
                                    style={{height:'100%'}}
                                    onClose={handleDetailsClickClose}
                                    TransitionComponent={Transition}
                                >
                                    <DialogTitle>新增採購</DialogTitle>
                                    <DialogContent>
                                    請將料品先選擇、刪除完畢後，再修改數量、批號，不然數量會被清空。<br/>
                                    請注意操作流程。
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        style={{marginBottom :'20px'}}
                                        id="name"
                                        label="圖號"
                                        type="text" // 如果是輸入單號，應該使用 type="text" 而不是 type="email"
                                        value={drawNum}
                                        onChange={(e) => setDrawNum(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                handleDetailsOptionsClick(drawNum);
                                                e.preventDefault(); // 防止表單提交
                                            }
                                        }}
                                        fullWidth
                                        variant="standard"
                                    />
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">料品選擇</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={item}
                                            label="Age"
                                            onChange={handleDetailChange}
                                        >
                                        {detailOptions.map((item) => (
                                            <MenuItem key={item.id} value={item}>
                                                圖號:{item.圖號}  物品名:{item.物品名}  單位:{item.單位} 幣別:{item.幣別?.trim() || '未設定'} 單價:{formatItemOptionPrice(item)}
                                                {item.requiresInventoryCard ? '（寫入資材卡，批號必填）' : '（不寫入資材卡，批號選填）'}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    </FormControl>
                                    <DataGrid
                                        apiRef={addGridApiRef}
                                        rows={addBillRows}
                                        columns={addBillcolumns}
                                        pageSize={10}
                                        rowHeight={30}
                                        headerHeight={32} 
                                        rowsPerPageOptions={[5, 10, 20]}
                                        processRowUpdate={processAddRowUpdate}
                                        onProcessRowUpdateError={error=>alert(error)}
                                        onCellEditStart={(params) => {
                                            activeAddEditCellRef.current = { id: params.id, field: params.field };
                                        }}
                                        onRowEditCommit={(rowId, e) => {
                                            handleAddSave(rowId,e);
                                        }}
                                    />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleDetailsClickClose}>取消</Button>
                                        {
                                            canEditPurchase && ((!request.單號 || request.單號 === 'new' || request.單號.trim() === '') ? (
                                                <Button onClick={() => handleSubmit(inventoryControl)}>新增採購</Button>
                                            ) : (
                                                <Button onClick={handlereplace}>更新採購</Button>
                                            ))
                                        }
                                    </DialogActions>
                                </Dialog>
                                <Dialog
                                     fullScreen
                                     open={pdfOpen}
                                     onClose={handlePdfClickClose}
                                     TransitionComponent={Transition}
                                        >
                                        <AppBar sx={{ position: 'relative' }}>
                                        <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handlePdfClickClose}
                                            aria-label="close"
                                            >
                                            <CloseIcon />
                                        </IconButton>
                                         <Button autoFocus color="inherit" onClick={handlePdfClickClose}>
                                            列印預覽
                                            </Button>
                                            <Button autoFocus color="inherit" onClick={handleAfterPrintPdfClickClose}>
                                            已列印後按此紐關閉
                                            </Button>
                                        </Toolbar>
                                    </AppBar>
                                    {pdfBlobUrl && <iframe src={pdfBlobUrl} title="PDF Document" style={{ width: '100%', height: '100%' }} />}
                                </Dialog>
                                <Dialog open={priceDialogOpen} onClose={() => setPriceDialogOpen(false)}>
                                    <DialogTitle>是否更改單價？</DialogTitle>
                                        <DialogContent>
                                        <DialogContentText>
                                        圖號：{selectedRow?.圖號}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => setPriceDialogOpen(false)}>取消</Button>
                                        <Button
                                            onClick={async () => {
                                                await handleUpdatePrice(selectedRow);
                                                setPriceDialogOpen(false);
                                            }}
                                        color="primary"
                                         >
                                        確定
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                            </Grid>
                        </Box>
                        <div style={{ overflowX: 'auto', width: '100%', height: '500px'  }}>
                            <div style={{ minWidth: '1200px', height: '100%' }}>
                                <DataGrid
                                rows={billRows}
                                columns={billcolumns}
                                pageSize={10}
                                rowsPerPageOptions={[5, 10, 20]}
                                processRowUpdate={processRowUpdate}
                                onProcessRowUpdateError={error=>alert(error)}
                                onRowEditCommit={(rowId, e) => {
                                handleSave(rowId,e);
                                }}
                                onRowDoubleClick={handlePriceChangeDoubleClick} // 新增這行
                                />
                            </div>
                        </div>

                    </div>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>請輸入查詢單號</DialogTitle>
                <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="單號"
                    type="email"
                    value={orderNum}
                    onChange={(e) => setOrderNum(e.target.value)}
                    fullWidth
                    variant="standard"
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose}>取消</Button>
                <Button onClick={handleSearchClick}>搜尋</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

Font.register({
    family: 'TaipeiSansTCBeta-Bold',
    src: 'path/to/TaipeiSansTCBeta-Bold.ttf', // 替换为您的实际字体文件路径
  });
  Font.register({
    family: 'TaipeiSansTCBeta-Light',
    src: 'path/to/TaipeiSansTCBeta-Light.ttf', // 替换为您的实际字体文件路径
  });
  // 页面宽高转换为点（1cm = 28.28点）
  const pageWidth = 24.1 * 72 / 2.54;
  const pageHeight = 14 * 72 / 2.54;
  
  // 表格宽度比例，根据您的表格设计调整
  const cellWidth = pageWidth / 6; // 假设有8列
  

  const BOMstyles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 24,
        width: pageWidth,
        height: pageHeight,
    },
    onePage: {
        flexDirection: 'row',
        backgroundColor: 'white',
        padding: 24,
        width: pageWidth,
        height: pageHeight,
    },
    title: {
        fontSize: 20,
        textAlign: 'center',
        fontFamily: 'TaipeiSansTCBeta-Bold',
        marginBottom: 10,
    },
    tableContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        fontFamily: 'TaipeiSansTCBeta-Bold', // 新增此行以确保容器内的内容（标题）居中
        width: '100%', // 确保容器宽度充满整个页面或其父容器
    },  
    headerRow: {
      flexDirection: 'row',
      width: '100%', // 确保行宽充满整个页面
      textAlign: 'center', 
      fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
      marginTop: 5, // 根据需要调整，为标题和标头之间提供一些空间
    },
    headerBottomRow: {
        flexDirection: 'row',
        width: '100%', // 确保行宽充满整个页面
        textAlign: 'center', 
        fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
        marginTop: 100, // 根据需要调整，为标题和标头之间提供一些空间
      },
    headerRowDash: {
      flexDirection: 'row',
      width: '100%', // 确保行宽充满整个页面
      textAlign: 'center', 
      fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
      marginTop: 10, // 标题和标头之间的空间
      borderTop: 1, // 添加上边框
      borderBottom: 1, // 添加下边框
      borderColor: 'black', // 边框颜色
      paddingTop: 5, // 标头内容与上边框之间的空间
      paddingBottom: 5, // 标头内容与下边框之间的空间
    },
    headerItem: {
        flex: 1, // 平分容器宽度
        textAlign: 'center', // 文本居中
        fontFamily: 'TaipeiSansTCBeta-Light',
        fontSize: 10,
    },
    header子件料號: {
      width: '15%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header品名: {
      width: '5%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header規格: {
      width: '25%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header配賦量: {
      width: '5%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header單位: {
      width: '10%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header需求量: {
      width: '10%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header實領: {
      width: '10%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
    header備註: {
      width: '20%',
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
    },
});
  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份需要加1，因为它从0开始
  const currentDay = String(currentDate.getDate()).padStart(2, '0');
  const dateString = `${currentDate.getFullYear()}/${currentMonth}/${currentDay}`;
  // 创建文档组件
  const MyBomDocument = ({ data,com,client,day,orderNum }) => ( 

    <Document>
        <Page size={{ width: pageWidth, height: pageHeight }} style={BOMstyles.page}>
            <View style={BOMstyles.tableContainer}>
                <Text style={BOMstyles.title}>{com} 請採購驗收單</Text>
            </View>
            <View style={BOMstyles.headerRow}>
                <Text style={BOMstyles.headerItem}>{client.manufacturer_AbbreviationName}</Text>
                <Text style={BOMstyles.headerItem}>月份選擇:{day}</Text>
                <Text style={BOMstyles.headerItem}>{orderNum}</Text>
                <Text style={BOMstyles.headerItem}>日期:{dateString}</Text>
            </View>
            {data.map((item, index) => (
                <>
                    <View style={BOMstyles.headerRow} key={index}>
                        <Text style={BOMstyles.headerItem}>{item.圖號}</Text>
                        <Text style={BOMstyles.headerItem}>{item.物品名}</Text>
                        <Text style={BOMstyles.headerItem}>{item.單位}</Text>
                        <Text style={BOMstyles.headerItem}>{item.數量}</Text> 
                        <Text style={BOMstyles.headerItem}>{item.單價}</Text>
                    </View>
                    <View style={BOMstyles.headerRow} key={index}>
                        <Text style={BOMstyles.headerItem}>批號:{item.批號}</Text>
                        <Text style={BOMstyles.headerItem}/>
                        <Text style={BOMstyles.headerItem}/>
                        <Text style={BOMstyles.headerItem}/>
                        <Text style={BOMstyles.headerItem}>{item.金額}</Text>
                    </View>
            </>            
            ))}
            <View style={BOMstyles.headerRow}>
                <Text style={BOMstyles.headerItem}>== 以下空白 ==</Text>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
            </View>
            <View style={BOMstyles.headerBottomRow}>
                <Text style={BOMstyles.headerItem}>{data[0].申請人}</Text>
                <Text style={BOMstyles.headerItem}>{data[0].主管}</Text>
                <Text style={BOMstyles.headerItem}>{data[0].核准}</Text>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}>金額總和:{ data.reduce((sum, item) => sum + Number(item.金額), 0)}</Text>
            </View>
            <View style={BOMstyles.headerRow}>
                <Text style={BOMstyles.headerItem}>*產品需符合ROSH*</Text>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
                <Text style={BOMstyles.headerItem}/>
            </View>
        </Page>
    </Document>
  );

